import { createTheme } from "@mui/material/styles";

import palette from "./palette";
import components from "./components";

const htmlFontSize = 16;

const theme = createTheme({
  palette,
  components,
  typography: {
    htmlFontSize,
    h1: {
      fontFamily: "'Nunito', sans-serif",
    },
    h2: {
      fontSize: 28,
      fontWeight: 500,
      lineHeight: 1.191,
      marginBottom: 19,
      color: palette.primary.light,
      fontFamily: "'Nunito', sans-serif",
    },
    h3: {
      fontFamily: "'Nunito', sans-serif",
    },
    h4: {
      fontFamily: "'Nunito', sans-serif",
    },
    h5: {
      fontFamily: "'Nunito', sans-serif",
    },
    h6: {
      fontFamily: "'Nunito', sans-serif",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 780,
      md: 960,
      lg: 1280,
      xl: 1920,
      mobile: 780,
      tablet: 1280,
    },
  },
  zIndex: {
    loadingModal: 1400,
    faceModal: 1400,
  },
  pxToRem: (px) => `${px / htmlFontSize}rem`,
  sizes: {
    desktop: {
      header: {
        height: 124,
      },
    },
    mobile: {
      header: {
        height: 68,
      },
    },
  },
});

export default theme;
